import { render, staticRenderFns } from "./WifiTypeChangeHistory.vue?vue&type=template&id=8c8f6c9e&scoped=true"
import script from "./WifiTypeChangeHistory.vue?vue&type=script&lang=js"
export * from "./WifiTypeChangeHistory.vue?vue&type=script&lang=js"
import style0 from "./WifiTypeChangeHistory.vue?vue&type=style&index=0&id=8c8f6c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8f6c9e",
  null
  
)

export default component.exports